/* eslint-disable */
"use strict";

import { ODUtil } from "./../../components/util.js";
import ODOffcanvas from "./../../components/offcanvas.js";

var ODLayoutQuickUser = function() {
    // Private properties
    var _element;
    var _offcanvasObject;

    // Private functions
    var _init = function() {
        var header = ODUtil.find(_element, '.offcanvas-header');
        var content = ODUtil.find(_element, '.offcanvas-content');

        _offcanvasObject = new ODOffcanvas(_element, {
            overlay: true,
            baseClass: 'offcanvas',
            placement: 'right',
            closeBy: 'od_quick_user_close',
            toggleBy: 'od_quick_user_toggle'
        });

        ODUtil.scrollInit(content, {
            disableForMobile: true,
            resetHeightOnDestroy: true,
            handleWindowResize: true,
            height: function() {
                var height = parseInt(ODUtil.getViewPort().height);

                if (header) {
                    height = height - parseInt(ODUtil.actualHeight(header));
                    height = height - parseInt(ODUtil.css(header, 'marginTop'));
                    height = height - parseInt(ODUtil.css(header, 'marginBottom'));
                }

                if (content) {
                    height = height - parseInt(ODUtil.css(content, 'marginTop'));
                    height = height - parseInt(ODUtil.css(content, 'marginBottom'));
                }

                height = height - parseInt(ODUtil.css(_element, 'paddingTop'));
                height = height - parseInt(ODUtil.css(_element, 'paddingBottom'));

                height = height - 2;

                return height;
            }
        });
    }

    // Public methods
    return {
        init: function(id) {
            _element = ODUtil.getById(id);

            if (!_element) {
                return;
            }

            // Initialize
            _init();
        },

        getElement: function() {
            return _element;
        }
    };
}();

// Webpack support
if (typeof module !== 'undefined') {
	// module.exports = ODLayoutQuickUser;
}

export default ODLayoutQuickUser;
